import React from "react";
import Image from "next/image";
export default function Divider({ description }) {
  return (
    <div className="w-full relative mt-20 flex flex-col items-center justify-center">
      <div className="relative w-full lg:h-[80vh] md:h-[50vh] h-[400px] ">
        <Image
          src="/images/pwac/content-bg-new.webp"
          alt="Address issue"
          fill
          className="object-cover object-center"
          sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px"
        />
      </div>

      <div className="bg-black/20 absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center lg:px-24 md:px-12 px-6 py-12">
        <p className="lg:text-lg text-white text-center lg:max-w-[800px] mx-auto">
          {description}
        </p>
      </div>
    </div>
  );
}
